import { BlockExtraFieldsEditingReason, UserProfileEditRestrictions } from "client/Api/UserProfile/service";
import { useAlertDialog } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement, useMemo } from "react";

export function useEditRestrictionsMoreInfo(
	editRestrictions: UserProfileEditRestrictions | undefined
): [onMoreInfo: (() => void) | undefined, dialog: ReactElement | null] {
	const fieldsBlockReasonMessage: string | undefined = useMemo(
		() => {

			const fieldsBlockReason: BlockExtraFieldsEditingReason | undefined =
				editRestrictions?.fieldsBlockReason;

			switch (fieldsBlockReason) {
				case BlockExtraFieldsEditingReason.SyncWithActiveDirectoryIsEnabled:
					return localize("_CanNotEditPageBecauseADSync");
				default:
					return undefined;
			}
		},
		[editRestrictions]
	);

	const [alertDialog, openAlertDialog] = useAlertDialog();

	const moreInfoHandler = useMemo(
		(): (() => void) | undefined => {
			if (!fieldsBlockReasonMessage) {
				return undefined;
			}

			return (): void => {
				openAlertDialog({
					title: localize("_UserProfile"),
					trackingId: "user-profile-blocked-edit-info-dialog",
					showCloseButton: true,
					children: fieldsBlockReasonMessage
				});
			};
		},
		[fieldsBlockReasonMessage, openAlertDialog]
	);

	return [
		moreInfoHandler,
		alertDialog
	];
}
